import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";
import variableEffects from "@/base/global/variables/figma.effects.json";

export const menuThemeToken: any = {
  //======================== COLORS =========================//
  darkItemBg: variableColors["ColorFigmaComplementaryBlue50"],
  darkPopupBg: variableColors["ColorFigmaComplementaryBlue50"],
  darkSubMenuItemBg: variableColors["ColorFigmaComplementaryBlue50"],
  darkItemHoverBg: variableColors["ColorFigmaComplementaryBlue60"],
  darkItemSelectedBg: variableColors["ColorFigmaComplementaryBlue60"],

  colorSplit: variableColors["ColorFigmaNeutralWhiteWhite100"],
  darkItemColor: variableColors["ColorFigmaNeutralWhiteWhite100"],
  darkItemSelectedColor: variableColors["ColorFigmaNeutralWhiteWhite100"],
  darkItemDisabledColor:
    variableColors["ColorFigmaNeutralGrayscaleGray60Disabled"],

  //===================== BORDER =============================//
  horizontalItemBorderRadius: 0,
  itemBorderRadius: 0,
  subMenuItemBorderRadius: 0,
  borderRadius: 0,
  borderRadiusLG: 4,
  boxShadowSecondary: variableEffects["BoxShadowElevation3"],

  //================== SIZE ========================/
  fontFamily: variableTypography["BodyLargeFontFamily"],
  iconSize: parseInt(variableTypography["BodyH500FontSize"]),
  fontSize: parseInt(variableTypography["BodyLargeFontSize"]),
  fontSizeLG: parseInt(variableTypography["BodyLargeFontSize"]),
  collapsedIconSize: parseInt(variableTypography["BodyLargeFontSize"]),
  itemMarginBlock: 0,
  itemMarginInline: 0,
  itemHeight: 46,
  controlHeightLG: 56,
  padding: 16,
  paddingXS: 2,
};
